export default {
  BT_HDP: "Kèo chấp",
  BT_OU: "Tài/Xỉu",
  BT_ML: "Dòng Tiền",
  BT_1X2: "1X2",
  BT_1X2HDP: "Cược 3 cách",
  BT_CS: "Tỷ số chính xác",
  BT_OE: "Lẻ/Chẵn",
  BT_DC: "Nhân đôi cơ hội",
  BT_HTFT: "Hiệp 1/ Cả trận",
  BT_FGLG: "Bàn thắng đầu/ cuối",//"Bàn thắng đầu/Bàn thắng cuối",
  BT_TG: "Tổng số bàn thắng",
  BT_OR: "Vô địch",
  BT_ORZ: "Vô địch",

  BT_ANB: "Khách không bàn thắng",
  BT_BS: "Cả hai đội/ Một đội/ Không đội nào có bàn thắng",
  BT_CL: "Không bị ghi bàn",
  BT_DNB: "Hoà không bàn thắng",
  BT_HNB: "Chủ nhà không bàn thắng",
  BT_TWTN: "Lật ngược tình thế",

  BT_HDPF: "Kèo chấp cả trận",
  BT_OUF: "Tài/Xỉu cả trận",
  BT_MLF: "Dòng tiền cả trận",
  BT_1X2F: "1X2 cả trận",
  BT_1X2HDPF: "Cược 3 cách cả trận",
  BT_CSF: "Tỷ số chính xác cả trận",
  BT_OEF: "Lẻ/Chẵn cả trận",
  BT_DCF: "Nhân đôi cơ hội cả trận",
  BT_FGLGF: "Bàn thắng đầu/Bàn thắng cuối cả trận",
  BT_TGF: "Tổng số bàn thắng cả trận",

  BT_HDPH: "Kèo chấp hiệp 1",
  BT_OUH: "Tài/Xỉu hiệp 1",
  BT_MLH: "Dòng tiền hiệp 1",
  BT_1X2H: "1X2 hiệp 1",
  BT_1X2HDPH: "Cược 3 cách hiệp 1",
  BT_CSH: "Tỷ số chính xác hiệp 1",
  BT_OEH: "Lẻ/Chẵn hiệp 1",
  BT_DCH: "Nhân đôi cơ hội hiệp 1",
  BT_FGLGH: "Bàn thắng đầu/Bàn thắng cuối hiệp 1",
  BT_TGH: "Tổng số bàn thắng hiệp 1",

  BT_HDPOU: "Kèo chấp và tài/xỉu",
  BT_PARLAY: "Xiên hỗn hợp",
  BT_FT: "Cả trận ",
  BT_1H: "Hiệp 1 ",
  BT_2H: "Hiệp 2 ",

  BT_FG: "Bàn thắng đầu",
  BT_LG: "Bàn thắng cuối",
  BT_HFG: "HF",//"Chủ nhà có bàn thắng đầu",
  BT_AFG: "AF",//"Khách có bàn thắng đầu",
  BT_HLG: "HL",//"Chủ nhà có bàn thắng cuối",
  BT_ALG: "AL",//"Khách có bàn thắng cuối",
  BT_NG: "NG",
  BT_HY: "Chủ nhà có",
  BT_HN: "chủ nhà không",
  BT_AY: "Khách có",
  BT_AN: "Khách không",
  BT_H: "Chủ nhà",
  BT_A: "Khách",
  BT_D: "Hoà",
  BT_HD_DC: "HD",//"Hiệp 1 chủ nhà thắng/Cả trận hoà",
  BT_HA_DC: "HA",//"Hiệp 1 chủ nhà thắng/Cả trận khách thắng",
  BT_DA_DC: "DA",//"Hiệp 1 hoà/Cả trận khách thắng",
  BT_HH: "HH",//"Hiệp 1 chủ nhà thắng/Cả trận chủ nhà thắng",
  BT_HD: "HD",//"Hiệp 1 chủ nhà thắng/Cả trận hoà",
  BT_HA: "HA",//"Hiệp 1 chủ nhà thắng/Cả trận khách thắng",
  BT_DH: "DH",//"Hiệp 1 hoà/Cả trận chủ nhà thắng",
  BT_DD: "DD",//"Hiệp 1 hoà/Cả trận hoà",
  BT_DA: "DA",//"Hiệp 1 hoà/Cả trận khách thắng",
  BT_AH: "AH",//"Hiệp 1 khách thắng/Cả trận chủ nhà thắng",
  BT_AD: "AD",//"Hiệp 1 khách thắng/Cả trận hoà",
  BT_AA: "AA",//"Hiệp 1 khách thắng/Cả trận khách thắng",

  BT_Y: "Có",
  BT_N: "Không",

  BT_LIVE: "Trực tiếp",
  BT_HT: "Nửa giờ",
  BT_DELAYED: "Trì hoãn",
  BT_PEN: "Luân lưu",

  BT_FT1: "Cả trận chủ nhà thắng",
  BT_FT2: "Cả trận khách thắng",
  BT_FTX: "Cả trận hoà",

  BT_HT1: "Hiệp 1 chủ nhà thắng",
  BT_HT2: "Hiệp 1 khách thắng",
  BT_HTX: "Hiệp 1 hoà",

  BT_BOTH: "Cả hai đội",
  BT_ONE: "Một đội",

  LOT_BS: "B/S",
  LOT_BIG: "B",
  LOT_SMALL: "S",
  LOT_OE: "O/E",
  LOT_ODD: "O",
  LOT_EVEN: "E",
  LOT_OU: "O/U",
  LOT_OVER: "O",
  LOT_UNDER: "U",

  BT_ALL: "@:ui.bet_list",

  BT_HDPMMO: "HDPMMO",
  BT_OUMMO: "OUMMO"
};